<template>
  <b-container style="margin-top:15px">
    <b-row>
      <b-card-group deck v-loading="loading"> 
        <b-card header="Hesabımı Düzenle" header-tag="header">
            <b-row>
              <b-col cols="3">
                  <b-form-group label="İsim">
                    <b-form-input size="sm" v-model="form.name" placeholder="İsim"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="3">
                  <b-form-group label="Soyisim">
                    <b-form-input size="sm" v-model="form.surname" placeholder="Soyisim"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="3">
                  <b-form-group label="Email">
                    <b-form-input type="email" size="sm" v-model="form.email" placeholder="Email"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="3">
                  <b-form-group label="Şifre">
                    <b-form-input type="password" size="sm" v-model="form.password" placeholder="Şifre"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="3">
                  <b-form-group label="Telefon">
                    <b-form-input type="number" onKeyDown="if(this.value.length==11 && event.keyCode!=8) return false;" size="sm" v-model="form.phone" placeholder="Telefon"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="3">
                  <b-form-group label="Vergi Dairesi">
                    <b-form-input size="sm" v-model="form.tax" placeholder="Vergi Dairesi"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="3">
                  <b-form-group label="Vergi Numarası">
                    <b-form-input type="number" onKeyDown="if(this.value.length==10 && event.keyCode!=8) return false;"  size="sm" v-model="form.tax_number" placeholder="Vergi Numarası"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="3">
                  <b-form-group label="Adres">
                    <b-form-input size="sm" v-model="form.address" placeholder="Adres"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="3">
                  <b-form-group label="TC Kimlik Numarası">
                    <b-form-input type="number" onKeyDown="if(this.value.length==11 && event.keyCode!=8) return false;"  size="sm" v-model="form.identity_id" placeholder="TC Kimlik Numarası"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col cols="3">
                  <b-form-group style="margin-top:29px">
                    <b-button @click="send()" style="width:100%" variant="primary" size="sm">Güncelle</b-button>
                  </b-form-group>
              </b-col>
            </b-row>
        </b-card>
      </b-card-group>
    </b-row>
  </b-container>
</template>

<script>
  export default{
    name: 'UsersDetail',
    data(){
      return{
        id: this.$route.params.id,
        loading: false,
        form:{
          name:null,
          surname:null,
          email:null,
          password:null,
          phone:null,
          tax:null,
          client_id:null,
          tax_number:null,
          address:null,
          identity_id:null, 
          type:null,
        }
      }
    },
    created(){
      this.form.name = this.user.name;
      this.form.surname = this.user.surname;
      this.form.email = this.user.email;
      this.form.phone = this.user.phone;
      this.form.tax_place = this.user.tax_place;
      this.form.client_id = this.user.client_id;
      this.form.tax_number = this.user.tax_number;
      this.form.address = this.user.address;
      this.form.identity_id = this.user.identity_id;
      this.form.type = this.user.type;
    },
    computed:{
      user(){
        return this.$user();
      },
      init(){
        return this.$store.getters['getInit'];
      },
    },
    methods:{
      send(){
        this.loading = true;
        axios.patch('/account', this.form)
        .then((response) => {
            this.$store.dispatch('alert/message', { type: 'success', title: 'Güncelleme Başarılı'});
            this.$store.dispatch('auth/userFetch');
            this.$router.push({name: 'MyAccount'});
        })
        .catch((err) => {
        })
        .finally(()=>{
            this.loading = false;
        })
      },
    }
  }
</script>